// user reduce type
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const SET_LEVEL = 'SET_LEVEL'
export const LOADING_USER = 'LOADING_USER'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_AUTH_LOADER = 'SET_AUTH_LOADER'
// app reducer types
export const SET_ERRORS = 'SET_ERRORS'
export const LOADING_UI = 'LOADING_UI'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'

// app reducer stories
export const RESET_STORY = 'RESET_STORY'
export const SET_STORY_LOADING = 'SET_STORY_LOADING'
export const SET_STORY = 'SET_STORY'
export const SET_STORIES = 'SET_STORIES'
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP'
export const SET_LAST_STEP = 'SET_LAST_STEP'
export const SET_PREVENT_REDIRECT = 'SET_PREVENT_REDIRECT'
export const SET_SHOW_RECORDING_SUCCESS = 'SET_SHOW_RECORDING_SUCCESS'
export const SET_STORIES_LIST = 'SET_STORIES_LIST'
export const SET_STORIES_LIST_LOADER = 'SET_STORIES_LIST_LOADER'
export const SET_IS_SUBMIT = 'SET_IS_SUBMIT'
export const SET_PINYIN_SETTINGS = 'SET_PINYIN_SETTINGS'
export const SET_STORY_DIFFICULTY = 'SET_STORY_DIFFICULTY'
export const SET_AUDIO_PRONUNCIATION_SETTING = 'SET_AUDIO_PRONUNCIATION_SETTING'
export const SET_WORD_DETAIL = 'SET_WORD_DETAIL'
export const SET_WORD_TYPES_OF_CURRENT_STORY = 'SET_WORD_TYPES_OF_CURRENT_STORY'
export const CHECK_WORD_IS_CLICKED = 'CHECK_WORD_IS_CLICKED'
export const SET_STORY_DICTIONARY = 'SET_STORY_DICTIONARY'
export const PATCH_STORY_DICTIONARY_WORD = 'PATCH_STORY_DICTIONARY_WORD'
export const PATCH_STORY_WORD_TYPE = 'PATCH_STORY_WORD_TYPE'
export const CLEAR_STORY_DICTIONARY = 'CLEAR_STORY_DICTIONARY'
export const SET_DICTIONARY_LOADING = 'SET_DICTIONARY_LOADING'
//app reducer quiz
export const SET_QUIZ = 'SET_QUIZ'
export const RESET_QUIZ = 'RESET_QUIZ'
export const SET_SUBMIT_QUIZ = 'SET_SUBMIT_QUIZ'
export const SET_GENERAL_RESULT = 'SET_GENERAL_RESULT'

//app reducer question
export const SET_QUESTION = 'SET_QUESTION'
export const SET_QUESTION_ANSWER_LIST = 'SET_QUESTION_ANSWER_LIST'
export const CLEAR_QUESTION_ANSWER_LIST = 'CLEAR_QUESTION_ANSWER_LIST'
export const SET_SUBMIT_QUESTION = 'SET_SUBMIT_QUESTION'
export const SET_CURRENT_ANSWER = 'SET_CURRENT_ANSWER'

//my Account
export const ACCOUNT_SET_PROFILE = 'ACCOUNT_SET_PROFILE'
export const ACCOUNT_SET_LEVEL_DONE = 'ACCOUNT_SET_LEVEL_DONE'
export const ACCOUNT_SET_CHARACTER_DONE = 'ACCOUNT_SET_CHARACTER_DONE'
export const ACCOUNT_SET_LANGUAGE_DONE = 'ACCOUNT_SET_LANGUAGE_DONE'
export const ACCOUNT_SET_FIRST_NAME_DONE = 'ACCOUNT_SET_FIRST_NAME_DONE'
export const ACCOUNT_SET_EMAIL_DONE = 'ACCOUNT_SET_EMAIL_DONE'
export const ACCOUNT_SET_PASSWORD_DONE = 'ACCOUNT_SET_PASSWORD_DONE'
export const ACCOUNT_UPDATE_ERRORS = 'ACCOUNT_UPDATE_ERRORS'
export const ACCOUNT_SET_HACK_CHINESE = 'ACCOUNT_SET_HACK_CHINESE'
export const ACCOUNT_REMOVE_HACK_CHINESE = 'ACCOUNT_REMOVE_HACK_CHINESE'

export const ACCOUNT_SET_SKRITTER = 'ACCOUNT_SET_SKRITTER'
export const ACCOUNT_REMOVE_SKRITTER = 'ACCOUNT_REMOVE_SKRITTER'

//streak

export const CURRENT_STREAK_LOADING = 'CURRENT_STREAK_LOADING'
export const LONGEST_STREAK_LOADING = 'LONGEST_STREAK_LOADING'
export const SET_LONGEST_STREAK = 'SET_LONGEST_STREAK'
export const SET_CURRENT_STREAK = 'SET_CURRENT_STREAK'
export const CURRENT_MONTH_STREAK_LOADING = 'CURRENT_MONTH_STREAK_LOADING'
export const SET_MONTH_STREAK = 'SET_MONTH_STREAK'

//app reducer dashboard
export const SET_CORRECTIONS = 'SET_CORRECTIONS'
export const SET_CURRENT_CORRECTION = 'SET_CURRENT_CORRECTION'
export const SET_CHINESE_WORD_FONT_SIZE = 'SET_CHINESE_WORD_FONT_SIZE'
export const SET_IS_MOB_NAV = 'SET_IS_MOB_NAV'

//app reducer recording
export const SET_CURRENT_RECORDING = 'SET_CURRENT_RECORDING'

// app reducer Corrections
export const SET_CORRECTION_DATA = 'SET_CORRECTION_DATA'
export const SET_CORRECTION_COUNT = 'SET_CORRECTION_COUNT'
export const SET_CORRECTION_ANSWER = 'SET_CORRECTION_ANSWER'
export const SET_CORRECTION_ERRORS = 'SET_CORRECTION_ERRORS'
export const SET_WORD_TYPES_OF_CORRECTION = 'SET_WORD_TYPES_OF_CORRECTION'
export const SET_CORRECTION_STORY = 'SET_CORRECTION_STORY'
export const SET_CORRECTION_QUESTION = 'SET_CORRECTION_QUESTION'

// app reducer on-boarding

export const SET_ALL_LANGUAGE = 'SET_ALL_LANGUAGE'
export const SET_LANGUAGE_INFO = 'SET_LANGUAGE_INFO'
export const SET_ALL_WORDS = 'SET_ALL_WORDS'
export const SET_WORDSLIST = 'SET_WORDSLIST'
export const SET_WORD_RESULT = 'SET_WORD_RESULT'
export const SET_IS_RESULT = 'SET_IS_RESULT'
export const SET_STEPPER_STEP = 'SET_STEPPER_STEP'
export const RESET_ONBOARDING = 'RESET_ONBOARDING'
export const SET_USERTYPE = 'SET_USERTYPE'
export const MANAGE_WORDLIST_LOADER = 'MANAGE_WORDLIST_LOADER'
export const SET_ISFREETRIAL = 'SET_ISFREETRIAL'
export const SET_ISLEADUSER = 'SET_ISLEADUSER'
export const SET_LOADER_RECOMMENDED = 'SET_LOADER_RECOMMENDED'

// test-first onboarding flow
export const SET_GOAL = 'SET_GOAL'
export const SET_ONBOARDING_NAME = 'SET_ONBOARDING_NAME'
export const SET_ONBOARDING_EMAIL = 'SET_ONBOARDING_EMAIL'
export const SET_EXPERIENCE = 'SET_EXPERIENCE'
export const SET_EXAM_BAND = 'SET_EXAM_BAND'
export const SET_PREFERENCE_TYPE = 'SET_PREFERENCE_TYPE'
export const SET_PLACEMENT = 'SET_PLACEMENT'
export const SET_PLACEMENT_DONE = 'SET_PLACEMENT_DONE'

// which grouped screen the user is on, and how much of it is revealed
export const SET_ONBOARDING_GROUP = 'SET_ONBOARDING_GROUP'
export const SET_GROUP_REVEAL = 'SET_GROUP_REVEAL'

// learn about maayot
export const SET_LEARN_ABOUT_LOADING = 'SET_LEARN_ABOUT_LOADING'
export const SET_LEARN_ABOUT = 'SET_LEARN_ABOUT'
export const SET_LEARN_ABOUT_TYPE = 'SET_LEARN_ABOUT_TYPE'
export const SET_LEARN_ABOUT_TITLE = 'SET_LEARN_ABOUT_TITLE'
export const SET_LEARN_ABOUT_ANSWER = 'SET_LEARN_ABOUT_ANSWER'

// story level selection
export const SET_PREFERRED_STORY_LEVEL = 'SET_PREFERRED_STORY_LEVEL'
export const SET_STORIES_BY_LEVEL = 'SET_STORIES_BY_LEVEL'
export const SET_STORIES_BY_LEVEL_LOADING = 'SET_STORIES_BY_LEVEL_LOADING'

// words
export const SET_WORDS_LIST = 'SET_WORDS_LIST'
export const SET_WORDS_LOADING = 'SET_WORDS_LOADING'
export const SET_WORDS_FILTERS = 'SET_WORDS_FILTERS'
export const PATCH_WORD_MASTERY = 'PATCH_WORD_MASTERY'
export const SET_AUTO_MASTERY_UPDATES = 'SET_AUTO_MASTERY_UPDATES'
export const SET_WORDS_PAGE = 'SET_WORDS_PAGE'
export const SET_WORDS_SELECTION = 'SET_WORDS_SELECTION'
export const SET_WORDS_SELECT_ALL_MATCHING = 'SET_WORDS_SELECT_ALL_MATCHING'
export const CLEAR_WORDS_CACHE = 'CLEAR_WORDS_CACHE'
export const PATCH_WORDS_MASTERY_BULK = 'PATCH_WORDS_MASTERY_BULK'
export const SET_WORDS_STATS = 'SET_WORDS_STATS'

// word pocket
export const SET_POCKET = 'SET_POCKET'
export const POCKET_ADD = 'POCKET_ADD'
export const POCKET_REMOVE = 'POCKET_REMOVE'
export const POCKET_PENDING = 'POCKET_PENDING'
